import React from 'react';
import ShopListing from '../components/shop/ShopListing';

// /products/search?category=&value=<texto> — resultados del buscador del header
const SearchProducts = () => <ShopListing />;

export default SearchProducts;
